import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { cn } from "@/lib/utils";
import { Icon } from "@bookips/sds";
import * as AccordionPrimitive from "@radix-ui/react-accordion";
import { forwardRef } from "react";
const AccordionRoot = /*#__PURE__*/ forwardRef((param, ref)=>/*#__PURE__*/ {
    let { className , ...props } = param;
    return _jsx(AccordionPrimitive.Root, {
        ref: ref,
        className: cn("w-full", className),
        ...props
    });
});
AccordionRoot.displayName = "Accordion.Root";
const AccordionItem = /*#__PURE__*/ forwardRef((param, ref)=>/*#__PURE__*/ {
    let { className , border ="bottom" , rounded =false , ...props } = param;
    return _jsx(AccordionPrimitive.Item, {
        ref: ref,
        className: cn("overflow-hidden bg-white", border === "bottom" && "border-b border-gray-200", border === "all" && "border border-gray-200", border === "ring" && "data-[state=open]:ring-1 data-[state=open]:ring-gray-700 data-[state=open]:border-none", rounded && "rounded-lg", className),
        ...props
    });
});
AccordionItem.displayName = "Accordion.Item";
const AccordionTrigger = /*#__PURE__*/ forwardRef((param, ref)=>/*#__PURE__*/ {
    let { className , children , hideIcon =false , iconPosition ="right" , iconClassName , ...props } = param;
    return _jsx(AccordionPrimitive.Header, {
        className: "flex",
        children: /*#__PURE__*/ _jsxs(AccordionPrimitive.Trigger, {
            ref: ref,
            className: cn("flex flex-1 items-center justify-between transition-all cursor-pointer", "hover:bg-gray-50", "[&[data-state=open]>div>.accordion-icon]:rotate-180", className),
            ...props,
            children: [
                iconPosition === "left" && !hideIcon && /*#__PURE__*/ _jsx("div", {
                    className: "flex items-center justify-center shrink-0 p-4",
                    children: /*#__PURE__*/ _jsx(Icon.ArrowDown_2px, {
                        className: cn("accordion-icon w-6 h-6 text-primary transition-transform duration-200", iconClassName)
                    })
                }),
                children,
                iconPosition === "right" && !hideIcon && /*#__PURE__*/ _jsx("div", {
                    className: "flex items-center justify-center shrink-0 p-4",
                    children: /*#__PURE__*/ _jsx(Icon.ArrowDown_2px, {
                        className: cn("accordion-icon w-6 h-6 text-primary transition-transform duration-200", iconClassName)
                    })
                })
            ]
        })
    });
});
AccordionTrigger.displayName = "Accordion.Trigger";
const AccordionContent = /*#__PURE__*/ forwardRef((param, ref)=>/*#__PURE__*/ {
    let { className , children , ...props } = param;
    return _jsx(AccordionPrimitive.Content, {
        ref: ref,
        className: cn("overflow-hidden", "data-[state=closed]:animate-accordion-up data-[state=open]:animate-accordion-down", className),
        ...props,
        children: children
    });
});
AccordionContent.displayName = "Accordion.Content";
export const Accordion = {
    Root: AccordionRoot,
    Item: AccordionItem,
    Trigger: AccordionTrigger,
    Content: AccordionContent
};
